import styled from 'styled-components';

import { colors, fontWeights, fonts, transition } from 'theme';

export const StyledSelect = styled.select.attrs<{
  disableGreyOnNull?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}>(({ disableGreyOnNull, value }) => ({
  style:
    !disableGreyOnNull && (value === null || value === '')
      ? {
          color: colors.battleshipGrey,
        }
      : null,
}))<{ small?: boolean; hasError?: boolean }>`
  width: 100%;
  height: 45px;
  padding-left: 1em;
  padding-right: 36px;
  border: solid 1px ${colors.silver};
  color: ${colors.charcoalGrey};
  background-color: white;
  border-radius: 8px;
  appearance: none;
  font-size: 18px;
  font-family: ${fonts.sans};
  transition: all ${transition};
  &:focus {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue} inset;
    outline: 0;
  }
  ${(props) =>
    props.hasError &&
    `
    border-color: ${colors.scarlet};
    box-shadow: 0 0 0 1px ${colors.scarlet};
  `}
  &::-ms-expand {
    display: none;
  }
  option {
    color: ${colors.greyishBrown};
  }
  ${(props) =>
    props.small &&
    `
  height: 36px;
  padding-right: 48px;
  padding-left: 12px;
  background: transparent;
  color: ${colors.battleshipGrey};
  font-size: 16px;
  font-weight: ${fontWeights.semiBold};
  `}
`;
